import React from 'react';
import styled from 'styled-components';
import { StyledInput } from '../../components/StyledInput';
import PropTypes from 'prop-types';
import { Checkbox } from '../../components/Checkbox';
import { OfferingType } from '../../utils/offeringType';
import { Column, TwoColumnLayout } from '../../components/TwoColumnLayout';

const Wrapper = styled.div`
	margin: auto;
	h4 {
		text-align: center;
	}
`;

const FormContainer = styled.div`
	width: 100%;
	margin-top: 2em;
	margin-bottom: 1em;
`;

const InputContainer = styled.div`
	margin-top: 2em;
	height: 2.2em;
`;

const ErrorMessage = styled.div`
	color: red;
`;

const StyledLink = styled.a`
	color: red;
`;

const termsAcceptedMessage = (offeringType) => {
	let termsLink = null;
	if (offeringType === OfferingType.CONSUMER2B) {
		termsLink = 'https://asiakaspalvelu.moi.fi/hc/fi/articles/360029156932-Palvelukuvaus';
	} else if (offeringType === OfferingType.CONSUMER3) {
		termsLink = 'https://www.moi.fi/yleiset-sopimukset-ja-palvelukohtaiset-ehdot-2019';
	} else if (offeringType === OfferingType.CONSUMER4) {
		termsLink = 'https://www.moi.fi/yleiset-sopimukset-ja-palvelukohtaiset-ehdot-2020';
	} else {
		return null;
	}
	return (
		<p>
			Hyväksyn{' '}
			<StyledLink href={termsLink} target="_blank">
				{' '}
				yleiset palvelu- ja sopimusehdot
			</StyledLink>
		</p>
	);
};

const transferNumberAutomaticallyMessage = (
	<p>
		Minulle sopii, että puhelinnumerot siirretään, vaikka niissä olisi määkäaikainen sopimus nykyisellä operaattorilla. Moi siirtää puhelinnumerot uusiin liittymiin minun puolestani, joten en irtisano
		vanhoja liittymiäni itse.
	</p>
);

const SelectBillingAddress = (props) => (
	<Wrapper>
		<h4>Anna toimitusosoite ja hyväksy tilaus</h4>
		<FormContainer>
			<TwoColumnLayout>
				<Column>
					<InputContainer className={'left-align'}>
						<StyledInput title={'Vastaanottajan nimi'} name={'recipientName'} backgroundColor={'white'} onChange={props.onBillingAddressChange} value={props.billingAddress.recipientName.value} />
						{props.showErrors && !props.billingAddress.recipientName.valid && <ErrorMessage>Tarkista kenttä</ErrorMessage>}
					</InputContainer>
				</Column>
				<Column>
					<InputContainer className={'right-align'}>
						<StyledInput title={'Katuosoite'} name={'streetAddress'} backgroundColor={'white'} onChange={props.onBillingAddressChange} value={props.billingAddress.streetAddress.value} />
						{props.showErrors && !props.billingAddress.streetAddress.valid && <ErrorMessage>Tarkista kenttä</ErrorMessage>}
					</InputContainer>
				</Column>
			</TwoColumnLayout>
			<TwoColumnLayout>
				<Column>
					<InputContainer>
						<StyledInput title={'Postinumero'} name={'postalCode'} backgroundColor={'white'} onChange={props.onBillingAddressChange} value={props.billingAddress.postalCode.value} />
						{props.showErrors && !props.billingAddress.postalCode.valid && <ErrorMessage>Tarkista kenttä</ErrorMessage>}
					</InputContainer>
				</Column>
				<Column>
					<InputContainer className={'right-align'}>
						<StyledInput title={'Postitoimipaikka'} name={'city'} backgroundColor={'white'} onChange={props.onBillingAddressChange} value={props.billingAddress.city.value} />
						{props.showErrors && !props.billingAddress.city.valid && <ErrorMessage>Tarkista kenttä</ErrorMessage>}
					</InputContainer>
				</Column>
			</TwoColumnLayout>
		</FormContainer>
		<Checkbox messageWidth={'90%'} checked={props.termsAccepted} message={termsAcceptedMessage(props.offeringType)} onChange={props.termsCheckBoxHandler} />
		{(props.hasMnpSubscriptions() || props.selectedSubscription.isMnp) && (
			<Checkbox messageWidth={'90%'} checked={props.transferNumberAutomatically} message={transferNumberAutomaticallyMessage} onChange={props.transferNumberAutomaticallyHandler} />
		)}
	</Wrapper>
);

SelectBillingAddress.propTypes = {
	onBillingAddressChange: PropTypes.func,
	billingAddress: PropTypes.object,
	showErrors: PropTypes.bool,
	termsAccepted: PropTypes.bool,
	termsCheckBoxHandler: PropTypes.func,
	transferNumberAutomaticallyHandler: PropTypes.func,
	selectedSubscription: PropTypes.object,
	transferNumberAutomatically: PropTypes.bool,
	hasMnpSubscriptions: PropTypes.func
};

export default SelectBillingAddress;
